import type { Guide, GuideRecordHint } from '../types';

/**
 * S-26.10-07 — jawne źródło ceny i decyzje o dodatkach w oknie kontroli (scenariusz e2e 36; makieta
 * p. Mariusza z 21.10, BR-ADM-03, BR-ADM-04, ścieżki ADM-01, ADM-03). Rekord D36A z `scenario-state.mjs`:
 * zlecenie bezpośrednie Administracji z wózkiem (dodatek „czynność wózkowa”), bez decyzji — nagrywarka
 * niczego nie zapisuje.
 */
const CONTROL: GuideRecordHint = {
  description: 'prezlecenie u Administracji, zaakceptowane, przed eksportem — z kolejki „Do kontroli”',
  listPath: '/pre-orders',
  listFilter: { intakeQueue: 'adm_control' },
};

export const guide: Guide = {
  flagKey: 'intakeControlPriceSurcharges',
  title: 'Okno kontroli: jawne źródło ceny i decyzje o dodatkach',
  whatItDoes:
    'Na liście „Do zrobienia” w oknie kontroli Administracja wskazuje, skąd jest cena zlecenia: dokument klienta (który) albo stawka SPOT — kto ją ustalił, kiedy i skąd. Cenników jeszcze nie ma. Zlecenie bez ceny można zwrócić do CS z pytaniem o SPOT. Dodatki z prezlecenia — korekta paliwowa kontrahenta i czynność wózkowa — potwierdza się albo odrzuca z powodem. Wszystko blokuje eksport do TMS jak spółka i VAT i trafia do historii.',
  audience: ['Administracja', 'administrator'],
  presentationItems: ['S-26.10-07'],
  steps: [
    {
      route: '/pre-orders/:preOrderId/control',
      record: CONTROL,
      target: 'intake-decision-price',
      mockupTestId: 'adm-zlecenie-cena-spot',
      title: 'Cena: skąd jest',
      description:
        'Przy cenie zlecenia trzy drogi: „Z dokumentu klienta…”, „SPOT…” i „Z cennika” — ta ostatnia nieaktywna, dopóki Marathon nie przekaże cenników. Jeśli CS wpisał cenę ze źródłem ustalenia, widać to pod ceną.',
      action: 'Sprawdź cenę i wybierz jej źródło.',
      recorder: { account: 'adm', demo: { kind: 'scenario', key: 'd36aPreOrderId' } },
    },
    {
      route: '/pre-orders/:preOrderId/control',
      record: CONTROL,
      target: 'intake-decision-spot-by',
      title: 'SPOT ze śladem: kto, kiedy, skąd',
      description:
        'Stawka SPOT wymaga śladu: kto ją ustalił, kiedy i skąd (telefon, mail poza systemem, ustalenie ustne albo inne z opisem). Ślad zostaje przy decyzji i w historii prezlecenia.',
      action: 'Wpisz, kto ustalił stawkę, wybierz źródło i datę, a potem „Zapisz decyzję”.',
      recorder: {
        account: 'adm',
        demo: { kind: 'scenario', key: 'd36aPreOrderId' },
        actions: [{ kind: 'click', target: 'adm-zlecenie-cena-spot' }],
      },
    },
    {
      route: '/pre-orders/:preOrderId/control',
      record: CONTROL,
      target: 'adm-zlecenie-cena-zwrot-cs',
      title: 'Zwrot do CS: potwierdź SPOT',
      description:
        'Gdy nie wiadomo, skąd jest cena (albo jej nie ma), prezlecenie wraca do CS z gotowym pytaniem o stawkę. Podjęte decyzje zostają.',
      action: 'Kliknij „Zwróć do CS: potwierdź SPOT”, popraw pytanie i wyślij.',
      recorder: { account: 'adm', demo: { kind: 'scenario', key: 'd36aPreOrderId' } },
    },
    {
      route: '/pre-orders/:preOrderId/control',
      record: CONTROL,
      target: 'intake-decisions-surcharges',
      mockupTestId: 'adm-zlecenie-dodatki',
      title: 'Dodatki: potwierdź albo odrzuć',
      description:
        'Lista dodatków z prezlecenia: korekta paliwowa obowiązująca dla kontrahenta (z kartoteki korekt) i czynność wózkowa przy aucie z wózkiem. Każdy dodatek „Potwierdź” albo „Odrzuć…” z powodem. Katalogu dodatków klienta jeszcze nie ma.',
      action: 'Przy każdym dodatku kliknij „Potwierdź” albo „Odrzuć…” i wpisz powód.',
      recorder: { account: 'adm', demo: { kind: 'scenario', key: 'd36aPreOrderId' } },
    },
  ],
};
